// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__vGDWV","mobile":"sidebar_mobile__TkRQN","nav":"sidebar_nav__lMsse","active":"sidebar_active__WUHi4","widget":"sidebar_widget__EzwTx"};